var _path, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMicrosoftOffice365(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.042 13.5124L21.93 13.5804C21.7515 13.6884 21.583 13.8094 21.426 13.9414L21.75 13.7134H24.5L25 17.4994L22.5 19.9994L20 21.7369V23.7404C20 25.1399 20.7315 26.4374 21.9285 27.1624L24.5605 28.7554L19 31.9994H17.9275L15.9285 30.7894C14.7315 30.0649 14 28.7669 14 27.3674V20.6299C14 19.2299 14.732 17.9319 15.93 17.2074L21.93 13.5779C21.967 13.5554 22.0045 13.5334 22.042 13.5124Z",
    fill: "url(#paint0_radial_21573_193343)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28 21.4994V23.7394C28 25.1389 27.2685 26.4364 26.0715 27.1614L20.0715 30.7934C18.844 31.5364 17.317 31.5634 16.068 30.8739L21.929 34.4214C23.2025 35.1924 24.7985 35.1924 26.0715 34.4214L32.0715 30.7894C33.2685 30.0649 34 28.7669 34 27.3674V25.7494L33.5 24.9994L28 21.4994Z",
    fill: "url(#paint1_radial_21573_193343)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.07 17.2069L26.07 13.5774C24.8365 12.8314 23.301 12.8084 22.0485 13.5079L21.93 13.5804C20.732 14.3049 20 15.6034 20 17.0029V21.7449L21.93 20.5774C23.203 19.8074 24.7975 19.8074 26.0705 20.5774L32.0705 24.2069C33.231 24.9089 33.954 26.1489 33.998 27.4984C33.9995 27.4549 34 27.4114 34 27.3674V20.6294C34 19.2299 33.268 17.9314 32.07 17.2069Z",
    fill: "url(#paint2_radial_21573_193343)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_21573_193343",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(26.215 17.5179) rotate(119.774) scale(20.113 46.0445)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.064,
    stopColor: "#BF8AF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.533,
    stopColor: "#3079D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#11408C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_21573_193343",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(15.2587 27.1116) rotate(-12.1282) scale(17.5224 16.5147)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.211,
    stopColor: "#BF8AF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#591C96"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_21573_193343",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(32.5218 25.2736) rotate(-165.772) scale(14.8291 24.9633)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.059,
    stopColor: "#50E6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#3079D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#11408C"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicrosoftOffice365);
export default __webpack_public_path__ + "static/media/MicrosoftOffice365.58f831a3e81afc48f0b96664cea518ff.svg";
export { ForwardRef as ReactComponent };